export default __webpack_public_path__ + "static/media/qr.1e8153ff.svg";